/**
 * feature-config flag names owned by user expansion
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const USER_EXPANSION_FLAG_NAMES = {
  DASHBAORD_SHARE_INVITE: `ff-plex-200-dashboard-share-invite`,
  ENABLE_STARTER_WORKSPACE_PURCHASES: `ff-exp-310-support-starter-workspaces-canvas-purchase`,
  STRICT_INVITE_RATE_LIMITS: 'ff-exp-38-strict-invite-rate-limits',
  COMMENT_EMAIL_SEND_IMMEDIATELY: 'ff-exp-212-comment-email-send-immediately',
  STA_FROM_DASHBOARD: 'ff-exp-327-sta-from-dashboard',
  GUEST_CLIENT_SHARE_LINKS: 'ff-exp-541-guest-client-share-links',
  SITEROLEMAPS_BY_WORKSPACE_AND_USER_MIGRATION:
    'ff-exp-498-domain-based-siterolemaps-by-workspace',
  BULK_ADD_SITE_ROLE_MAPS_MIGRATION: 'ff-exp-496-domain-based-bulk-siterolemap',
} as const;

export const USER_EXPANSION_EXPERIMENT_NAMES = {
  ONE_CLICK_ACCEPT_INVITE: 'exp-plex-190-one-click-accept-invite',
} as const;
